import { lazy, Suspense } from "react";

import Loader from "../customs/Customspinner/spinner";

const Main = lazy(() => import("../components/profile/main"));

const Profile = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Main />
    </Suspense>
  );
};

export default Profile;
